import React from 'react';
import { Box, Button} from '@chakra-ui/react';
import { FaPlus} from 'react-icons/fa';

const AddStores = () => {
  return (
    <Box>
      <Button
        onClick={() => alert('test')}
        variant="outline"
        colorScheme="blue"
        justifyContent="flex-start"
        leftIcon={<FaPlus />}
      >
        Add Stores
      </Button>
    </Box>
  );
};

export default AddStores;